import NegotiationHome from "./negotiation-home";
import CaseNegotiation from "./case-negotiation";
import NegotiationDetails from "./negotiation-details";

export { CaseNegotiation, NegotiationDetails };
export default NegotiationHome;